import { ApolloProvider } from '@apollo/client/react';
import { Fragment, Suspense } from 'react';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';

import apollo from './apollo';
import AutoScroll from './components/Atoms/AutoScroll';
import CapacitorSplashScreenAutoHide from './components/Atoms/CapacitorSplashScreenAutoHide';
import SentryErrorBoundary from './components/Atoms/SentryErrorBoundary';
import { ROUTER_MODE, SENTRY_DSN } from './config';
import { LanguageProvider } from './contexts/LanguageContext';
import { WindowProvider } from './contexts/WindowContext';
import Routes from './routes';
import Layout from './views/Layout/Layout';

const SentryErrorHandler = SENTRY_DSN ? SentryErrorBoundary : Fragment;

// Use MemoryRouter on apps instead of BrowserRouter
const DynamicRouter = (props) =>
  ROUTER_MODE === 'MEMORY' ? <MemoryRouter {...props} /> : <BrowserRouter {...props} />;

const App = () => (
  <SentryErrorHandler>
    <ApolloProvider client={apollo}>
      <LanguageProvider>
        <DynamicRouter>
          <WindowProvider>
            <AutoScroll />
            <Layout>
              <Routes />
            </Layout>
          </WindowProvider>
        </DynamicRouter>
      </LanguageProvider>
    </ApolloProvider>
    <Suspense fallback={null}>
      <CapacitorSplashScreenAutoHide />
    </Suspense>
  </SentryErrorHandler>
);

export default App;
